import _omitBy from 'lodash/omitBy';
import _isUndefined from 'lodash/isUndefined';
import _isEmpty from 'lodash/isEmpty';
import convert from 'color-convert';

const utils = {
  omit: v => {
    const vv = _omitBy(v, _isUndefined);
    return _omitBy(vv, v => !v);
  },
  hexToRgb: (hex, format = 'object') => {
    const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const result = r
      ? {
          r: parseInt(r[1], 16),
          g: parseInt(r[2], 16),
          b: parseInt(r[3], 16),
        }
      : '';
    if (format === 'object' || !result) return result;
    if (format === 'rgbaObject') return {...result, a: 1};
    if (format === 'rgbString')
      return `rgb(${result.r}, ${result.g}, ${result.b})`;
    if (format === 'rgbaString')
      return `rgba(${result.r}, ${result.g}, ${result.b}, 1)`;
    if (format === 'array') return [result.r, result.g, result.b];
  },
  rgbToHex: ({r, g, b}) =>
    '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1),
  isValidHex: string => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i.test(string),
  hasWhite: s =>
    s &&
    s.match(
      /(?:white|#fff(?:fff)?|rgba?\(\s*255\s*,\s*255\s*,\s*255\s*(?:,\s*1\s*)?\))/i
    ),
  lightOrDark: color => {
    let r, g, b, hsp;
    if (color.match(/^rgb/)) {
      color = color.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
      );
      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      // If hex --> Convert it to RGB
      color = utils.hexToRgb(color);
      r = color >> 16;
      g = (color >> 8) & 255;
      b = color & 255;
    }
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
      return 'light';
    } else {
      return 'dark';
    }
  },
  labToHex: lab => {
    let l, a, b;
    if (Array.isArray(lab)) {
      l = parseFloat(lab[0]);
      a = parseFloat(lab[1]);
      b = parseFloat(lab[2]);
    } else {
      l = parseFloat(lab.l);
      a = parseFloat(lab.a);
      b = parseFloat(lab.b);
    }
    if ((!l && l !== 0) || (!a && a !== 0) || (!b && b !== 0)) return '';
    return `#${convert.lab.hex(parseFloat(l), parseFloat(a), parseFloat(b))}`;
  },
  rgbaStrToObj: str => {
    if (!str) return {};
    const match = str.match(
      /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*(?:\.\d+)?)\)$/
    );
    return match
      ? {
          r: Number(match[1]),
          g: Number(match[2]),
          b: Number(match[3]),
          a: Number(match[4]),
        }
      : {};
  },
  rgbStrToObj: str => {
    if (!str) return {};
    const match = str.match(/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/);
    return match
      ? {
          r: Number(match[1]),
          g: Number(match[2]),
          b: Number(match[3]),
        }
      : {};
  },
  rgbaObjToStr: obj => `rgba(${obj.r},${obj.g},${obj.b},${obj.a})`,
  rgbObjToStr: obj => `rgb(${obj.r},${obj.g},${obj.b})`,
  rgbaStringToHex: (str = '', enableAlpha) => {
    const rgbaObj = utils.rgbaStrToObj(str);
    if (_isEmpty(rgbaObj)) {
      return enableAlpha ? {} : '';
    }
    const alpha = rgbaObj.a * 100;
    delete rgbaObj.a;
    const hex = utils.rgbToHex(rgbaObj);
    return enableAlpha ? {hex, alpha} : hex;
  },
  rgbStringToHex: (str = '') => {
    const rgbObj = utils.rgbStrToObj(str);
    if (_isEmpty(rgbObj)) {
      return '';
    }
    const hex = utils.rgbToHex(rgbObj);
    return hex;
  },
  average2Colors: (color1, color2) => {
    const hex1 = utils.hexToRgb(color1);
    const hex2 = utils.hexToRgb(color2);
  },
};

export default utils;
